import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const createCourse = async (course) => {
  return await addDoc(collection(db, "courses"), {
    ...course,
    createdAt: serverTimestamp(),
  });
};